export default __webpack_public_path__ + "static/media/logo-musaned.baf5d351.svg";